import React from 'react';
import { Switch, Route } from "react-router-dom";

import Dashboard from '../Dashboard/Dashboard';
import Events from './../Events/Events';
import Event from './../../components/Event/Event';
import Orders from './../Orders/Orders';
import Settings from './../../components/Settings/Settings';
import Notifications from './../Notifications/Notifications';

import Toastr from './../../components/Layout/Toastr/Toastr';
import Header from './../../components/Layout/Header/Header';
import Page from '../../components/Layout/Page/Page';

import './App.css';

function App() {

  return (

      <div className="App">

        <Toastr />

        <Header />

        <Page>
          <Switch>
            <Route path="/settings" component={Settings} />
            <Route exact path="/events" component={Events} />
            <Route path="/events/:eventID" component={Event} />
            <Route exact path="/orders" component={Orders} />
            <Route exact path="/" component={Dashboard} />
            <Route path="/notifications" component={Notifications} />
          </Switch>
        </Page>

      </div>
  );
}

export default App;